export default __webpack_public_path__ + "fonts/ai_1.2c9d3faab64d928b5a26a215f7ec4bb6.png";